import Vue from 'vue/dist/vue';
import DealerAgreement from './vue/components/dealer-agreement.vue';
import AnnualReturn from './vue/components/annual-return.vue';

Vue.config.devtools = false;
Vue.config.productionTip = false;

// ==================================================
// INITIALIZERS
// ==================================================
function setListeners() {
    document.addEventListener('DOMContentLoaded', removeHiddenDisplayStyling);
}

function removeHiddenDisplayStyling() {
    setTimeout(() => {
        document.body.className = document.body.className.replace(' js', '');
    }, 205);
}

function init() {
    setListeners();

    // ==================================================
    // VUE INIT (Dealer Agreement)
    // ==================================================
    const dealerAgreementEl = document.querySelector('#dealer-agreement');
    if (dealerAgreementEl) {
        new Vue({
            el: dealerAgreementEl,
            components: { DealerAgreement },
            template: '<dealer-agreement />',
        });
    }

    // ==================================================
    // VUE INIT (Annual Return)
    // ==================================================
    const annualReturnEl = document.querySelector('#annual-return');
    if (annualReturnEl) {
        new Vue({
            el: annualReturnEl,
            components: { AnnualReturn },
            template: '<annual-return />',
        });
    }
}

export default init;
